export default __webpack_public_path__ + "static/media/titles.e119a8a9.png";